export default Object.freeze({
  NotConnected: -1,
  Offline: 0,
  Online: 1,
});

export let getString = function (status) {
  if (status == -1) {
    return "NotConnected";
  } else if (status == 0) {
    return "Offline";
  } else {
    return "Online";
  }
};
